import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './PortfolioSample.css';
import p1 from '../../../images/p1.PNG';
import p2 from '../../../images/p2.PNG';
import p3 from '../../../images/p3.PNG';
import { Link } from 'react-router-dom';

const projects = [
    {
        name: 'Driving School',
        img: p1,
        live: 'https://driving-school-client.web.app/',
        code: 'https://github.com/irajmunshy/driving-school-client'
    },
    {
        name: 'Fresh Shopping',
        img: p2,
        live: 'https://fresh-shoping.web.app/',
        code: 'https://github.com/irajmunshy/varieties-shop-client'
    },
    {
        name: 'Penguin Fashion',
        img: p3,
        live: 'https://irajmunshy.github.io/Responsive-Protfolio/',
        code: 'https://github.com/irajmunshy/Responsive-Protfolio'
    }
];

const PortfolioSample = () => {
    return (
        <div className="portfolioSample-area mt-5 py-1">
            <div className="container my-5">
                <h4 className="sub-title mb-5">Some of my Projects</h4>
                
                <div className="row pt-2">
                    {
                        projects.map(pd => 
                            <div className="col-md-4 mb-4 padd-15">
                                <div className="portfolio-item-inner shadow-dark">
                                    <div className="portfolio-img">
                                        <img src={pd.img} alt=""/>
                                    </div>

                                    <div className="portfolio-info">
                                        <h4>{pd.name}</h4>
                                        <div className="icon">
                                            <a href={pd.code}><FontAwesomeIcon icon={faGithub} /></a>
                                            <a href={pd.live} target="_blank"><FontAwesomeIcon icon={faPlay} /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }

                    <Link to="/portfolio" className="mt-5 btn custom-btn">More Projects</Link>
                </div>
            </div>
        </div>
    );
};

export default PortfolioSample;